export const getQueryString = (name: string) => {
    let querySearch = location.search.substr(1) || location.hash.split('?')[1] || '';
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = querySearch.match(reg);
    // if (r != null) {
    //     return unescape(r[2]);
    // }
    if(r!=null){
      return decodeURIComponent(r[2]);
    }
    return null;
};

export const setQueryString = (key: string, value: string | number) => {
    let url = window.location.href;
    let re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");
    let hash = url.split('#');

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                window.location.hash = '#' + hash[1].replace(re, '$1' + key + "=" + value + '$2$3');
            }
        } else {
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                window.location.hash = '#' + hash[1];
            }
        }
    } else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            let newHash = '#' + hash[1] + separator + key + '=' + value;
            window.location.hash = newHash;
        }
    }
};

